import axios from 'axios';
import {
  isTokenValid
} from "@/components/auth/AuthService.js"

//Create axios instance and config header to attach token
export const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(async function(config) {

    //If not authenticate, redirect to login page. With hist.goBack() will be returned to previos page
    var configVar = config;
      
    //add authorization header with jwt token if available
    const access_token = await isTokenValid();
    if (access_token != false) {
        configVar.headers.Authorization = `Bearer ${access_token}`;
    }

    return configVar;
       
}, function(err) {
  return Promise.reject(err);
});
